<template>
  <v-dialog :value="dialog" persistent max-width="600">
    <v-card>
      <v-card-title class="text-h5"> Create Classification Rule </v-card-title>

      <div class="px-5 my-5">
        <v-text-field
          label="Document Type"
          placeholder="e.g., Invoice, Medical Report, Contract"
          outlined
          v-model="documentType"
          :rules="documentTypeRules"
        ></v-text-field>

        <v-textarea
          label="Description"
          placeholder="Describe the characteristics that identify this document type..."
          outlined
          rows="4"
          v-model="description"
          :rules="descriptionRules"
        ></v-textarea>
      </div>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="$emit('close')"> Cancel </v-btn>
        <v-btn
          color="blue darken-1"
          text
          @click="addRule"
          :disabled="!isFormValid"
        >
          Create
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapActions: rulesActions } = createNamespacedHelpers('classificationRules');

export default {
  name: 'CreateClassificationRule',
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      documentType: '',
      description: '',
      documentTypeRules: [
        v => !!v || 'Document type is required',
        v => (v && v.length <= 100) || 'Document type must be less than 100 characters',
      ],
      descriptionRules: [
        v => !!v || 'Description is required',
        v => (v && v.length <= 1000) || 'Description must be less than 1000 characters',
      ],
    };
  },
  computed: {
    isFormValid() {
      return this.documentType &&
             this.documentType.length <= 100 &&
             this.description &&
             this.description.length <= 1000;
    },
  },
  watch: {
    dialog(newValue) {
      if (!newValue) {
        this.documentType = '';
        this.description = '';
      }
    },
  },
  methods: {
    ...rulesActions(['createRule']),
    async addRule() {
      if (this.isFormValid) {
        try {
          const createdRule = await this.createRule({
            documentType: this.documentType,
            description: this.description,
          });

          if (createdRule && createdRule.id) {
            this.$emit('close');
          }
        } catch (error) {
          console.error('Error creating rule:', error);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
// Add any specific styling if needed
</style>